import { render, staticRenderFns } from "./TradeLogPanel.vue?vue&type=template&id=39384c06&scoped=true"
import script from "./TradeLogPanel.vue?vue&type=script&lang=js"
export * from "./TradeLogPanel.vue?vue&type=script&lang=js"
import style0 from "./TradeLogPanel.vue?vue&type=style&index=0&id=39384c06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_bddh7bz47tm4asog4nvkp26dru/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39384c06",
  null
  
)

export default component.exports